import { Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from './components/AppLayout';
import ProtectedRoute from './components/ProtectedRoute';
import { Guard } from './components/Guard';
import { useAuth } from './contexts/AuthContext';
import { isPlatformSuperadmin } from './lib/permissions';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Students from './pages/Students';
import StudentDetail from './pages/StudentDetail';
import Classes from './pages/Classes';
import ClassDetail from './pages/ClassDetail';
import Subjects from './pages/Subjects';
import SubjectDetail from './pages/SubjectDetail';
import Schedule from './pages/Schedule';
import Attendance from './pages/Attendance';
import Grades from './pages/Grades';
import Journal from './pages/Journal';
import AcademicYears from './pages/AcademicYears';
import Homework from './pages/Homework';
import HomeworkDetail from './pages/HomeworkDetail';
import Ranking from './pages/Ranking';
import Behavior from './pages/Behavior';
import TestExams from './pages/TestExams';
import Payments from './pages/Payments';
import Reports from './pages/Reports';
import Expenses from './pages/Expenses';
import Payroll from './pages/Payroll';
import Admissions from './pages/Admissions';
import Contracts from './pages/Contracts';
import Announcements from './pages/Announcements';
import AnnouncementDetail from './pages/AnnouncementDetail';
import Banners from './pages/Banners';
import BannerDetail from './pages/BannerDetail';
import Notifications from './pages/Notifications';
import Stickers from './pages/Stickers';
import Premium from './pages/Premium';
import Staff from './pages/Staff';
import FaceId from './pages/FaceId';
import StaffDetail from './pages/StaffDetail';
import Support from './pages/Support';
import Parents from './pages/Parents';
import ParentDetail from './pages/ParentDetail';
import Teachers from './pages/Teachers';
import TeacherDetail from './pages/TeacherDetail';
import Settings from './pages/Settings';
import PlatformSupport from './pages/PlatformSupport';
import Tenants from './pages/superadmin/Tenants';
import Qurilmalar from './pages/superadmin/Qurilmalar';
import Agentlar from './pages/superadmin/Agentlar';
import SaasPremium from './pages/superadmin/SaasPremium';
import SaasGifts from './pages/superadmin/SaasGifts';
import SaasSupport from './pages/superadmin/SaasSupport';
import Audit from './pages/superadmin/Audit';
import Legal from './pages/Legal';
import DeleteAccount from './pages/DeleteAccount';
import ContractDownload from './pages/ContractDownload';
import Kiosk from './pages/Kiosk';
import Ilova from './pages/Ilova';
import { CookieConsent } from './components/CookieConsent';

/** Bosh sahifa — superadmin uchun Maktablar, tenant admini uchun Dashboard. */
function Home() {
  const { user } = useAuth();
  if (isPlatformSuperadmin(user)) return <Navigate to="/tenants" replace />;
  return <Guard section="dashboard"><Dashboard /></Guard>;
}

export default function App() {
  return (
    <>
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* SATA ilovasi panelni shu manzil bilan ochadi (bir martalik kod → qurilma sessiyasi) */}
      <Route path="/ilova" element={<Ilova />} />
      {/* Huquqiy hujjatlar — OCHIQ (login talab qilmaydi) */}
      <Route path="/terms" element={<Legal docKey="terms" />} />
      <Route path="/privacy" element={<Legal docKey="privacy" />} />
      <Route path="/cookies" element={<Legal docKey="cookies" />} />
      {/* Akkauntni o'chirish (My SATA ilovasi, Google Play talabi) — OCHIQ, login va SATA ilovasisiz */}
      <Route path="/delete-account" element={<DeleteAccount />} />
      {/* Shartnoma yuklab olish — OCHIQ (havola: /docs/:token) */}
      <Route path="/docs/:token" element={<ContractDownload />} />
      {/* Kiosk TV ekrani — OCHIQ (maktab dahlizidagi televizor: /kiosk?key=...) */}
      <Route path="/kiosk" element={<Kiosk />} />
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Home />} />
        <Route path="/students" element={<Guard section="students"><Students /></Guard>} />
        <Route path="/students/:id" element={<Guard section="students"><StudentDetail /></Guard>} />
        <Route path="/classes" element={<Guard section="classes"><Classes /></Guard>} />
        <Route path="/classes/:id" element={<Guard section="classes"><ClassDetail /></Guard>} />
        <Route path="/subjects" element={<Guard section="subjects"><Subjects /></Guard>} />
        <Route path="/subjects/:id" element={<Guard section="subjects"><SubjectDetail /></Guard>} />
        <Route path="/schedule" element={<Guard section="schedule"><Schedule /></Guard>} />
        <Route path="/attendance" element={<Guard section="attendance"><Attendance /></Guard>} />
        <Route path="/grades" element={<Guard section="grades"><Grades /></Guard>} />
        <Route path="/journal" element={<Guard section="journal"><Journal /></Guard>} />
        <Route path="/academic-years" element={<Guard section="academic-years"><AcademicYears /></Guard>} />
        <Route path="/homework" element={<Guard section="homework"><Homework /></Guard>} />
        <Route path="/homework/:id" element={<Guard section="homework"><HomeworkDetail /></Guard>} />
        <Route path="/ranking" element={<Guard section="ranking"><Ranking /></Guard>} />
        <Route path="/behavior" element={<Guard section="behavior"><Behavior /></Guard>} />
        <Route path="/exams" element={<Guard section="exams"><TestExams /></Guard>} />
        <Route path="/payments" element={<Guard section="payments"><Payments /></Guard>} />
        <Route path="/reports" element={<Guard section="reports"><Reports /></Guard>} />
        <Route path="/expenses" element={<Guard section="expenses"><Expenses /></Guard>} />
        <Route path="/payroll" element={<Guard section="payroll"><Payroll /></Guard>} />
        <Route path="/admissions" element={<Guard section="admissions"><Admissions /></Guard>} />
        <Route path="/contracts" element={<Guard section="contracts"><Contracts /></Guard>} />
        <Route path="/announcements" element={<Guard section="announcements"><Announcements /></Guard>} />
        <Route path="/announcements/:id" element={<Guard section="announcements"><AnnouncementDetail /></Guard>} />
        <Route path="/banners" element={<Guard section="banners"><Banners /></Guard>} />
        <Route path="/banners/:id" element={<Guard section="banners"><BannerDetail /></Guard>} />
        <Route path="/notifications" element={<Guard section="notifications"><Notifications /></Guard>} />
        <Route path="/premium" element={<Guard section="premium"><Premium /></Guard>} />
        <Route path="/staff" element={<Guard section="staff"><Staff /></Guard>} />
        <Route path="/faceid" element={<Guard section="faceid"><FaceId /></Guard>} />
        <Route path="/staff/:id" element={<Guard section="staff"><StaffDetail /></Guard>} />
        <Route path="/support" element={<Guard section="support"><Support /></Guard>} />
        <Route path="/platform-support" element={<Guard section="platform-support"><PlatformSupport /></Guard>} />
        <Route path="/parents" element={<Guard section="parents"><Parents /></Guard>} />
        <Route path="/parents/:id" element={<Guard section="parents"><ParentDetail /></Guard>} />
        <Route path="/teachers" element={<Guard section="teachers"><Teachers /></Guard>} />
        <Route path="/teachers/:id" element={<Guard section="teachers"><TeacherDetail /></Guard>} />
        <Route path="/settings" element={<Guard section="settings"><Settings /></Guard>} />
        {/* SaaS platforma (superadmin) */}
        <Route path="/tenants" element={<Guard section="tenants"><Tenants /></Guard>} />
        <Route path="/qurilmalar" element={<Guard section="qurilmalar"><Qurilmalar /></Guard>} />
        <Route path="/superadmin/agentlar" element={<Guard section="agentlar"><Agentlar /></Guard>} />
        <Route path="/saas-premium" element={<Guard section="saas-premium"><SaasPremium /></Guard>} />
        <Route path="/saas-gifts" element={<Guard section="saas-gifts"><SaasGifts /></Guard>} />
        <Route path="/saas-support" element={<Guard section="saas-support"><SaasSupport /></Guard>} />
        <Route path="/audit" element={<Guard section="audit"><Audit /></Guard>} />
        <Route path="/stickers" element={<Guard section="stickers"><Stickers /></Guard>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    <CookieConsent />
    </>
  );
}
